/**
 * function will return processed number
 or false if it doesn't have a country code
 * @param number
 * @return {boolean|*}
 */
function handleNumberWithCountryCode(number) {
  if (number[0] === '1') {
    return number.slice(1, number.length);
  }

  return false;
}

/**
 * removes all characters that aren't numbers
 * @param number
 * @return {*}
 */
function stripCommonNumberCharacters(number) {
  return number.replace(/\D/g, '').trim();
}

export function getPhoneNumber(phoneNumber) {
  let numberInQuestion = `${phoneNumber}`;
  // strip out all non numerical characters
  numberInQuestion = stripCommonNumberCharacters(numberInQuestion);

  if (numberInQuestion.length !== 10) {
    // 11 chars could mean there is a country code
    if (numberInQuestion.length === 11) {
      // function will return processed number
      // or false if it doesn't have a country code
      return handleNumberWithCountryCode(numberInQuestion);
    }
    // number is invalid if there is not 10 digits in it
    // and not 11 digits with country code.

    return '';
  }

  return numberInQuestion;
}
